import { render, staticRenderFns } from "./SslPlans.vue?vue&type=template&id=4900f978&lang=true&"
import script from "./SslPlans.vue?vue&type=script&lang=js&"
export * from "./SslPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports